module.exports = __webpack_public_path__ + "img/64200.409d88c1.jpg";